import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import { Box, Dialog, DialogContent, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";

import ButtonBlue from "./ButtonBlue";

const StyledDialog = styled(Dialog)({
  "& .MuiDialogContent-root": {
    padding: 0,
    "& .content": {
      padding: 16,
      textAlign: "center",
      "& .delete-icon-label": {
        fontSize: 90,
        color: "#f15e5e",
      },
      "& .header-label": {
        padding: "20px 0",
      },
      "& .detail": {
        fontSize: 16,
        "& span": {
          color: "#f15e5e",
          fontSize: 20,
        },
      },
    },
  },
});

const DialogConfirmDelete = (props) => {
  const { open, handleClose, text,text1, handleDelete } = props;
  const { t, i18n } = useTranslation();

  return (
    <StyledDialog fullWidth maxWidth={"xs"} open={open} onClose={handleClose}>
      <DialogContent>
        <div
          style={{ width: "100%", height: 6, backgroundColor: "#f15e5e" }}
        ></div>
        <div className="content">
          <HighlightOffRoundedIcon className="delete-icon-label" />
          <Typography variant="h5" className="header-label" color="text.third">
            {t("AreYouSure")}?
          </Typography>

          <Typography className="detail" variant="h6" color="text.secondary">
            {text1}
          </Typography>
          <Typography className="detail" variant="h6" color="text.third">
            {text}
          </Typography>

          <Box
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
            }}
          >
            <ButtonBlue
              color="secondary"
              variant="text"
              style={{ marginRight: "10px" }}
              onClick={handleClose}
            >
              {t("Cancel")}
            </ButtonBlue>
            <ButtonBlue
              color="error"
              variant="contained"
              onClick={handleDelete}
            >
              ยืนยันลบ
            </ButtonBlue>
          </Box>
        </div>
      </DialogContent>
    </StyledDialog>
  );
};

export default DialogConfirmDelete;
